import Image from 'next/image'
import { forwardRef } from 'react'

import { CaseStudiesGraphic } from '../../../assets/icons'

import styles from './index.module.scss'

export const CaseStudiesHero = forwardRef<HTMLElement>((_, ref) => {
  return (
    <section className={styles['section-wrapper']} ref={ref}>
      <div className={styles['section-content']}>
        <div className={styles['content']}>
          <h1 className={styles['title']}>Case studies</h1>
          <p className={styles['description']}>
            We can make an <span className={styles['highlight']}>extraordinary future</span> happen
            together
          </p>
          <p className={styles['additional-info']}>
            Learn how Olby has helped companies scale their tech teams and achieve their business
            goals.
          </p>
        </div>
        <div className={styles['image-wrapper']}>
          <div className={styles['image-container']}>
            <Image
              src={'https://platform-statics.olby.com/case-studies.png'}
              fill
              sizes="(max-width: 703px) 28.5rem, (max-width: 1279px) 37.2rem, 52.4rem"
              className={styles['image']}
              alt="Man and woman look the camera smiling"
            />
          </div>
          <CaseStudiesGraphic className={styles['icon']} />
        </div>
      </div>
    </section>
  )
})
